import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { Logo } from "@/components/alia/logo";
import { toast } from "@/components/ui/toast";
import { useAuth } from "@/hooks/use-auth";
import { auth } from "@/lib/api";

// StrictMode monta el efecto dos veces en dev; el magic-link es de uso único,
// así que el segundo fetch siempre falla con token_invalido. Module-level
// para persistir entre re-mounts; se resetea al refresh de pestaña.
const attemptedTokens = new Set<string>();

export default function VerifyPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { signIn } = useAuth();

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      toast.error("Falta el token de verificación. Pide un nuevo link.");
      navigate("/login", { replace: true });
      return;
    }

    if (attemptedTokens.has(token)) return;
    attemptedTokens.add(token);

    (async () => {
      try {
        const session = await auth.verifyToken(token);
        signIn(session);
        navigate("/inbox", { replace: true });
      } catch (err) {
        toast.error(
          err instanceof Error
            ? err.message
            : "El link no es válido o ya expiró."
        );
        navigate("/login", { replace: true });
      }
    })();
  }, [params, navigate, signIn]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-6">
      <div className="mb-8">
        <Logo size={32} />
      </div>
      <div className="flex flex-col items-center gap-4 text-center">
        <div className="size-8 animate-spin rounded-full border-2 border-border border-t-brand" />
        <p className="text-sm text-muted-foreground">Verificando tu link…</p>
      </div>
    </div>
  );
}
